"use client"

import { Container, Row } from "reactstrap"
import EditMyProfile from "./EditMyProfile/EditMyProfile"
import EditProfileForm from "./EditProfileForm/EditProfileForm"
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs"
import { useEffect } from "react"

const EditProfileContainer = () => {
  // Optional: You can add any profile-specific logic here
  useEffect(() => {
    // This effect runs when the component mounts
    // The modal will automatically be hidden due to the route check in LeftHeader
  }, [])

  return (
    <>
      <Breadcrumbs mainTitle="Edit Profile" parent="Users" />
      <Container fluid>
        <div className="edit-profile">
          <Row>
            <EditMyProfile />
            <EditProfileForm />
          </Row>
        </div>
      </Container>
    </>
  )
}

export default EditProfileContainer
